import { useContext } from 'react';
import { useSnapshot } from 'valtio';

import { TournamentContext } from './TournamentContext';
import { TournamentState } from './TournamentStore';

export function useTournamentCtx() {
  const ctx = useContext(TournamentContext);
  if (!ctx) {
    throw new Error(
      'TournamentContext not initialized. Please, wrap your components in <TournamentProvider />',
    );
  }

  const snapshot = useSnapshot(ctx.state) as TournamentState;
  return { ...ctx, state: snapshot };
}
